<template>
  <q-item v-ripple clickable :class="itemClass">
    <q-item-section>
      <!-- Top row: Name + Date -->
      <div class="row justify-between items-center">
        <span class="text-weight-medium" :class="nameTextClass">
          {{ humanizeIdentifier(template?.elementName) || "-" }}
        </span>
        <span class="text-neutral-70" :class="dateTextClass">
          {{ formatDate(template?.lastModified, "DD MMM YYYY") }}
        </span>
      </div>

      <!-- Body Preview -->
      <div class="q-mt-xs">
        <span
          class="text-neutral-70 ellipsis"
          :class="bodyTextClass"
          v-html="template?.bodyOriginal?.slice(0, bodyPreviewLength)"
        ></span>
      </div>

      <!-- Category Badge -->
      <div class="q-mt-xs">
        <PBadge
          :label="template?.category"
          class="text-primary"
          :class="badgeClass"
        />
      </div>
    </q-item-section>
  </q-item>
</template>

<script setup>
import { date } from "quasar";
import { humanizeIdentifier } from "src/assets/scripts/utilities/helpers";

const { formatDate } = date;

const { isFloating } = inject("floating-chat-dialog", {});

defineProps({
  template: { type: Object, required: true },
});

// Computed classes based on isFloating
const itemClass = computed(() => (unref(isFloating) ? "q-pa-xxs" : ""));

const nameTextClass = computed(() =>
  unref(isFloating) ? "text-xs" : "text-sm",
);

const dateTextClass = computed(() =>
  unref(isFloating) ? "text-xxs" : "text-xs",
);

const bodyTextClass = computed(() =>
  unref(isFloating) ? "text-xxs" : "text-xs",
);

const badgeClass = computed(() => (unref(isFloating) ? "text-xxs" : ""));

const bodyPreviewLength = computed(() => (unref(isFloating) ? 57 : 100));
</script>
